// extracted by mini-css-extract-plugin
export default {"content":"style_content__7ziUv","form":"style_form__WpGE2"};